import { render, staticRenderFns } from "./PlayfieldName.vue?vue&type=template&id=116a8b7d&scoped=true&"
import script from "./PlayfieldName.vue?vue&type=script&lang=js&"
export * from "./PlayfieldName.vue?vue&type=script&lang=js&"
import style0 from "./PlayfieldName.vue?vue&type=style&index=0&id=116a8b7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116a8b7d",
  null
  
)

export default component.exports